import { render } from "react-dom";
import { createElement } from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { Root } from "./Root.fs.js";

render(createElement(Auth0Provider, {
    domain: "wecheck.eu.auth0.com",
    clientId: "QPTiBBHM5yOekw8ZqI9xlIqW4DY48jGK",
    redirectUri: window.location.origin,
    children: createElement(Root, null),
}), document.getElementById("feliz-app"));

